import React, { Component } from 'react';
import CancelUrl from '../CancelUrl/CancelUrl';
import FooterLinks from './FooterLinks';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { trackTransition } from '../../../framework/store/FPTI/FPTIActions';
import { FormattedMessage } from 'react-intl';
import './Footer.less';
import { showEscapeHatch } from '../EscapeHatch/EscapeHatchActions';
import { FLOW_TYPE } from '../../../framework/App/AppConstants';
import get from 'lodash/get';

const LOCALE_PREFIX = 'GB/components/Footer/Footer';

export class Footer extends Component {
    static propTypes = {
        dispatchCancelFPTI: PropTypes.func,
        errorType: PropTypes.string,
        pageName: PropTypes.string,
        showEscapeHatch: PropTypes.func,
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)),
        cancelUrlProvided: PropTypes.bool,
        // Passed in props
        cancelFptiEvent: PropTypes.shape({ // Convenience prop for FPTI tracking
            stateName: PropTypes.string,
            transitionName: PropTypes.string
        }),
        hasEscapeHatch: PropTypes.bool,
        cookieBannerAvailable: PropTypes.bool,
        showCancelUrl: PropTypes.bool
    };

    static defaultProps = {
        hasEscapeHatch: true,
        cookieBannerAvailable: false,
        showCancelUrl: true,
        cancelUrlProvided: true
    };

    handleShowEscapeHatch = () => {
        this.props.showEscapeHatch();
    };

    render() {
        const { cancelFptiEvent, errorType, hasEscapeHatch, showCancelUrl, cookieBannerAvailable, flow, cancelUrlProvided } = this.props;
        const isInvalidFlow = errorType === 'invalidFlow';
        const extraProps = hasEscapeHatch ? { customOnClick: this.handleShowEscapeHatch } : null;
        const isTesla = flow === FLOW_TYPE.TESLA;

        return (
            <footer id="cue-footer">
                <div className={`cue-footer-container ${cookieBannerAvailable ? 'cookieBanner' : ''}`}>
                    {showCancelUrl && !isInvalidFlow && cancelUrlProvided && (
                        <CancelUrl
                            {...extraProps}
                            id="footer_cancelUrl"
                            className="footer-cancelurl-apply backLink"
                            fptiEvent={cancelFptiEvent}
                        />
                    )}
                    {!isTesla && <FooterLinks />}

                    <div className="disclosure">
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.disclosure`}
                        />
                    </div>

                    {isTesla && <FooterLinks />}
                </div>
            </footer>
        );
    }
}

export const mapStateToProps = state => ({
    errorType: state.serverData.errorType,
    cookieBannerAvailable: state.serverData.cookieBannerAvailable || false,
    pageName: state.skeletonPage.currentPage,
    flow: get(state, 'serverData.flow'),
    cancelUrlProvided: get(state, 'serverData.cancelUrlProvided')
});

export const mapDispatchToProps = dispatch => ({
    dispatchCancelFPTI(pathName) {
        dispatch(trackTransition(`apply_pp_credit_${pathName}`, `cancel_and_return_apply_pp_credit_${pathName}`));
    },
    showEscapeHatch() {
        dispatch(showEscapeHatch());
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
